var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bind-wechat-wrapper"},[_c('general-table',{attrs:{"table-data":_vm.enterpriseList,"table-header":_vm.tableHeader,"action":_vm.action,"auto-height":"","show-empty":""}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d5318ac","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/RobotSetting/_components/WechatEnterpriseList.vue
// module id = null
// module chunks = 